import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal, Row, Col} from 'react-bootstrap';
import AddDiscouintlistsForm from './AddDiscouintlistsForm';
import * as courseActions from '../../actions/coursesActionCreators';
import label from '../../utils/lngEn';

class AddDiscountModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      discountlist: {
        title: '',
        courseId: '',
        groupsArray: [],
        initialValues: {
          id: '',
          group: '',
          amount: ''
        }
      },
      errorAmount: '',
      errorGroups: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({discountlist: nextProps.initial});
  }

  handleSubmit (values) {
    let promise = new Promise((resolve) => {
    if(!values.group) {
      this.setState({errorGroups: 'Required'});
    } else {
      this.setState({errorGroups: null});
    }
    if(!values.amount) {
      this.setState({errorAmount :'Required'});
    } else {
      this.setState({errorAmount: null});
    }
    return resolve();
  });
  promise.then(() => {
    return new Promise((resolve,reject) => {
      if(this.state.errorAmount !== null || this.state.errorGroups !== null) {
        return reject();
      } else {
        return resolve();
      }
    });
  }).then(()=> {
    let obj = {};
    if(typeof(values.group) == 'object') {
      obj.group = values.group.value
    } else {
      obj.group = values.group;
    }
    if(typeof(values.amount) == 'object') {
      obj.amount = values.amount.value;
    } else {
      obj.amount = values.amount;
    }
    if(values.id) {
      // Edit Discountlist
      obj.id = values.id;
      this.props.courseActions.putDiscount(this.state.discountlist.courseId , obj).then(() => {
        this.props.updateDiscountList();
        this.props.closeModal();
      }).catch(err => {
        console.log('error', err.message);
      })
    } else {
      // Add Discount
      this.props.courseActions.addNewDiscount(this.state.discountlist.courseId, obj).then(() => {
        this.props.updateDiscountList();
        this.props.closeModal();
      }).catch(err => {
        console.log('error', err.message);
      });
    }
  });

  }

  render(){
    // let {discountlist} = this.props;
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static" className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {this.state.discountlist.title || label.createDiscount}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{this.state.discountlist.initialValues.id ? '' : label.createDiscountlistModalBody}</p>
          <AddDiscouintlistsForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onCancel}
            initialValues={this.state.discountlist.initialValues}
            groupsArray={this.state.discountlist.groupsArray}
            errorAmount={this.state.errorAmount}
            errorGroups={this.state.errorGroups}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

AddDiscountModal.propTypes = {
  //myProp: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddDiscountModal);



// WEBPACK FOOTER //
// ./src/components/classes/AddDiscountModal.js